module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form-item', {
    attrs: {
      "label": "Tekst",
      "error": _vm.errors[_vm.addLanguageSuffix('text')]
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.form[_vm.addLanguageSuffix('text')]),
      callback: function($$v) {
        _vm.$set(_vm.form, _vm.addLanguageSuffix('text'), $$v)
      },
      expression: "form[addLanguageSuffix('text')]"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4ab93411"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/fields/forms/TextField.vue
// module id = 749
// module chunks = 0